import { cardWarnings, signatureCard } from './card';
import { archivedFilter, searchFilter, sortingFilter } from './filters';
import { studioOverview } from './overview';

let overviewSteps = [studioOverview, searchFilter, archivedFilter, sortingFilter, signatureCard, cardWarnings];

export const OVERVIEW_STEPS = overviewSteps;
